var $ef29867297882921$exports = {};
$ef29867297882921$exports = {
  "alert": "Opozorilo",
  "dismiss": "Opusti"
};
export { $ef29867297882921$exports as default };